import { catalogosApi } from './catalogos.services'

type AccionInvalidar = ReturnType<typeof catalogosApi.util.invalidateTags>

/**
 * Las acciones para tirar la caché de un catálogo después de escribirlo.
 *
 * El CRUD de estos catálogos no pasa por RTK Query —va por helpers HTTP disparados desde sagas y
 * componentes—, así que la caché no se enteraba de un alta ni de una baja. Estas acciones son el
 * aviso que faltaba: se despachan en el punto de escritura, apenas el servidor confirma.
 *
 * Van agrupadas acá y no sueltas en cada punto para que se vea de un vistazo qué escritura invalida
 * qué, y para que quien agregue un CRUD nuevo tenga dónde mirar.
 *
 * Todas aceptan el id opcional: con id se tira solo esa entrada; sin id, todas las del tipo. La
 * segunda forma es la salida cuando el punto de escritura no sabe a cuál le pegó.
 */

/** Un ámbito concreto de ListasSeleccion, o todos si no se sabe cuál. */
export const invalidarListaSeleccion = (ambito?: string): AccionInvalidar =>
  catalogosApi.util.invalidateTags(ambito ? [{ type: 'ListaSeleccion' as const, id: ambito }] : ['ListaSeleccion'])

/** La lista de embarcaciones que alimenta los buscadores y el combo de Generar Salidas. */
export const invalidarEmbarcaciones = (): AccionInvalidar => catalogosApi.util.invalidateTags(['Embarcacion'])

/** Los tipos de cabina de una embarcación, o los de todas si no se sabe. */
export const invalidarTipoCabinas = (embarcacionId?: number): AccionInvalidar =>
  catalogosApi.util.invalidateTags(
    embarcacionId === undefined ? ['TipoCabina'] : [{ type: 'TipoCabina' as const, id: embarcacionId }],
  )
